(function(){
"use strict";

var root=document.querySelector(".ptiq-ready");
if(!root)return;

var KEYS={
inspectionComplete:"ptiq_inspection_complete",
inspectionState:"ptiq_inspection_trainer_v1",
voiceComplete:"ptiq_voice_complete",
voiceState:"ptiq_voice_practice_v1",
partsComplete:"ptiq_parts_complete",
partsState:"ptiq_parts_iq_v1",
practiceComplete:"ptiq_practice_complete",
practiceHistory:"ptiq_practice_history_v1",
practiceState:"ptiq_practice_test_v1",
mockComplete:"ptiq_mock_test_complete",
mockHistory:"ptiq_mock_test_history_v1",
mockLast:"ptiq_mock_test_last_result_v1"
};

var URLS={
inspection:"/pages/inspection-iq",
voice:"/pages/voice-practice-iq",
parts:"/pages/parts-iq",
practice:"/pages/practice-tests",
mock:"/pages/mock-test",
study:"/pages/cdl-pre-trip-study-guide"
};

function getJSON(key,fallback){
try{
var value=JSON.parse(localStorage.getItem(key)||"null");
return value===null?fallback:value;
}catch(e){
return fallback;
}
}

function hasFlag(key){
try{
var value=localStorage.getItem(key);
return value==="1"||value==="true";
}catch(e){
return false;
}
}

function clamp(value,min,max){
return Math.max(min,Math.min(max,value));
}

function average(values){
if(!values.length)return 0;
return values.reduce(function(sum,value){return sum+value},0)/values.length;
}

function formatDate(timestamp){
if(!timestamp)return "Unknown date";
try{
return new Date(timestamp).toLocaleDateString(undefined,{month:"short",day:"numeric",year:"numeric"});
}catch(e){
return "Unknown date";
}
}

function formatTime(seconds){
seconds=Math.max(0,Math.round(seconds||0));
return Math.floor(seconds/60)+":"+String(seconds%60).padStart(2,"0");
}

function analyze(){
var inspectionState=getJSON(KEYS.inspectionState,{});
var voiceState=getJSON(KEYS.voiceState,{});
var partsState=getJSON(KEYS.partsState,{});
var practiceHistory=getJSON(KEYS.practiceHistory,[]);
var practiceState=getJSON(KEYS.practiceState,{});
var mockHistory=getJSON(KEYS.mockHistory,[]);
var mockLast=getJSON(KEYS.mockLast,null);

if(!Array.isArray(practiceHistory))practiceHistory=[];
if(!Array.isArray(mockHistory))mockHistory=[];

var inspectionComplete=hasFlag(KEYS.inspectionComplete);
var voiceComplete=hasFlag(KEYS.voiceComplete);
var partsComplete=hasFlag(KEYS.partsComplete);
var practiceComplete=hasFlag(KEYS.practiceComplete)||practiceHistory.length>0;
var mockComplete=hasFlag(KEYS.mockComplete)||!!mockLast||mockHistory.length>0;

var practiceScores=practiceHistory
.map(function(item){
if(!item||!item.total)return null;
return Math.round((Number(item.correct)||0)/(Number(item.total)||1)*100);
})
.filter(function(value){return value!==null});

var mockScores=mockHistory
.map(function(item){return Number(item&&item.scorePercent)})
.filter(function(value){return Number.isFinite(value)});

if(mockLast&&Number.isFinite(Number(mockLast.scorePercent))){
var lastScore=Number(mockLast.scorePercent);
if(!mockScores.length||mockScores[0]!==lastScore)mockScores.unshift(lastScore);
}

var latestPractice=practiceScores.length?practiceScores[0]:null;
var latestMock=mockLast&&Number.isFinite(Number(mockLast.scorePercent))?Number(mockLast.scorePercent):(mockScores.length?mockScores[0]:null);
var practiceAverage=practiceScores.length?Math.round(average(practiceScores.slice(0,5))):null;
var mockAverage=mockScores.length?Math.round(average(mockScores.slice(0,3))):null;
var unanswered=mockLast?Number(mockLast.unanswered)||0:0;

var categoryMap={};

practiceHistory.slice(0,5).forEach(function(test){
if(!test||!test.category||!test.total)return;
var name=test.category==="mixed"?"Mixed Practice":String(test.category);
if(!categoryMap[name])categoryMap[name]={correct:0,total:0};
categoryMap[name].correct+=Number(test.correct)||0;
categoryMap[name].total+=Number(test.total)||0;
});

var mockCategorySource=(mockLast&&mockLast.categoryStats)||{};
Object.keys(mockCategorySource).forEach(function(name){
var row=mockCategorySource[name]||{};
if(!categoryMap[name])categoryMap[name]={correct:0,total:0};
categoryMap[name].correct+=Number(row.correct)||0;
categoryMap[name].total+=Number(row.total)||0;
});

var categoryRows=Object.keys(categoryMap).map(function(name){
var row=categoryMap[name];
return {
name:name,
correct:row.correct,
total:row.total,
percent:row.total?Math.round(row.correct/row.total*100):0
};
}).sort(function(a,b){return a.percent-b.percent});

var completionCount=[inspectionComplete,voiceComplete,partsComplete,practiceComplete,mockComplete].filter(Boolean).length;
var evidenceCount=completionCount+Math.min(3,practiceHistory.length)+Math.min(3,mockHistory.length);

var score=0;
score+=inspectionComplete?12:0;
score+=voiceComplete?12:0;
score+=partsComplete?12:0;
score+=practiceComplete?8:0;
score+=mockComplete?10:0;

if(practiceAverage!==null)score+=Math.round(clamp(practiceAverage,0,100)*.18);
if(mockAverage!==null)score+=Math.round(clamp(mockAverage,0,100)*.28);

if(mockScores.length>=2){
var spread=Math.max.apply(null,mockScores.slice(0,3))-Math.min.apply(null,mockScores.slice(0,3));
if(spread<=7)score+=5;
else if(spread<=12)score+=3;
}

if(unanswered>0)score-=Math.min(8,unanswered*2);
if(mockLast&&mockLast.submissionReason==="time_expired")score-=4;
if(completionCount<3)score=Math.min(score,54);
if(!mockComplete)score=Math.min(score,69);
if(!inspectionComplete||!voiceComplete||!partsComplete)score=Math.min(score,79);
score=clamp(Math.round(score),0,100);

var confidence;
if(evidenceCount>=9&&mockScores.length>=2&&practiceScores.length>=2)confidence="High evidence";
else if(evidenceCount>=5&&mockScores.length>=1)confidence="Moderate evidence";
else confidence="Low evidence";

var stateLabel;
if(score<40)stateLabel="Not Ready Yet";
else if(score<65)stateLabel="Building Readiness";
else if(score<82)stateLabel="Nearly Ready";
else stateLabel="Ready to Test";

var strengths=[];
var gaps=[];

if(inspectionComplete)strengths.push({title:"Inspection path completed",copy:"You completed the guided component-by-component inspection trainer."});
else gaps.push({title:"Inspection IQ is incomplete",copy:"Finish the guided inspection sequence before relying on test scores.",url:URLS.inspection,label:"Open Inspection IQ"});

if(voiceComplete)strengths.push({title:"Spoken inspection completed",copy:"You completed Voice Practice IQ and practiced required concepts out loud."});
else gaps.push({title:"Spoken coverage is incomplete",copy:"Complete Voice Practice IQ so visual knowledge can be expressed clearly.",url:URLS.voice,label:"Open Voice Practice IQ"});

if(partsComplete)strengths.push({title:"Visual recognition completed",copy:"You completed Parts IQ and worked through component identification."});
else gaps.push({title:"Parts recognition is incomplete",copy:"Complete Parts IQ before treating written-test performance as full readiness.",url:URLS.parts,label:"Open Parts IQ"});

if(practiceAverage!==null){
if(practiceAverage>=85)strengths.push({title:"Strong practice average",copy:"Your recent untimed practice average is "+practiceAverage+"%."});
else gaps.push({title:"Practice accuracy needs work",copy:"Your recent untimed practice average is "+practiceAverage+"%. Review explanations and weak categories.",url:URLS.practice,label:"Open Practice Tests"});
}else{
gaps.push({title:"No completed practice history",copy:"Finish at least one untimed practice session to expose knowledge gaps.",url:URLS.practice,label:"Start Practice Test"});
}

if(latestMock!==null){
if(latestMock>=80)strengths.push({title:"Strong latest mock result",copy:"Your latest timed simulation score is "+latestMock+"%."});
else gaps.push({title:"Mock-test pressure score is low",copy:"Your latest timed simulation score is "+latestMock+"%. Return to weak-area practice.",url:URLS.mock,label:"Take Another Mock Test"});
}else{
gaps.push({title:"No timed simulation result",copy:"Complete a Mock Test before Readiness IQ can judge performance under pressure.",url:URLS.mock,label:"Start Mock Test"});
}

if(unanswered===0&&mockLast)strengths.push({title:"No unanswered questions",copy:"Your latest Mock Test was completed without leaving questions unanswered."});
if(unanswered>0)gaps.push({title:"Unanswered mock questions",copy:"Your latest Mock Test included "+unanswered+" unanswered question"+(unanswered===1?"":"s")+".",url:URLS.mock,label:"Retake Mock Test"});

if(categoryRows.length){
var weakest=categoryRows[0];
if(weakest.percent<75)gaps.push({title:weakest.name+" is the weakest measured area",copy:"Current combined accuracy is "+weakest.percent+"% across available test evidence.",url:URLS.practice,label:"Practice Weak Areas"});
var strongest=categoryRows[categoryRows.length-1];
if(strongest.percent>=85)strengths.push({title:strongest.name+" is a measured strength",copy:"Current combined accuracy is "+strongest.percent+"%."});
}

var consistencyText="Not enough evidence";
var consistencyCopy="Complete at least two timed simulations to judge consistency.";
if(mockScores.length>=2){
var recent=mockScores.slice(0,3);
var spread=Math.max.apply(null,recent)-Math.min.apply(null,recent);
if(spread<=7){consistencyText="Consistent";consistencyCopy="Recent mock scores are within "+spread+" points of each other."}
else if(spread<=12){consistencyText="Developing consistency";consistencyCopy="Recent mock scores vary by "+spread+" points."}
else{consistencyText="Inconsistent under pressure";consistencyCopy="Recent mock scores vary by "+spread+" points."}
}

var nextAction;
if(!inspectionComplete)nextAction={title:"Finish Inspection IQ",copy:"Complete the guided inspection trainer before advancing your readiness claim.",url:URLS.inspection,label:"Continue Inspection IQ"};
else if(!voiceComplete)nextAction={title:"Finish Voice Practice IQ",copy:"Practice saying the inspection clearly and covering required safety concepts.",url:URLS.voice,label:"Continue Voice Practice"};
else if(!partsComplete)nextAction={title:"Finish Parts IQ",copy:"Strengthen visual recognition before depending on written answers alone.",url:URLS.parts,label:"Continue Parts IQ"};
else if(practiceAverage===null||practiceAverage<80)nextAction={title:"Strengthen weak areas in Practice Tests",copy:"Use untimed explanations until recent practice performance is dependable.",url:URLS.practice,label:"Open Practice Tests"};
else if(latestMock===null)nextAction={title:"Complete a timed Mock Test",copy:"Readiness cannot be confirmed without a pressure-simulation result.",url:URLS.mock,label:"Start Mock Test"};
else if(latestMock<80||unanswered>0)nextAction={title:"Retake the Mock Test after review",copy:"Improve the weakest categories and eliminate unanswered questions.",url:URLS.mock,label:"Take Another Mock Test"};
else if(mockScores.length<2)nextAction={title:"Confirm the result with another Mock Test",copy:"One strong score is encouraging. A second strong result provides better evidence.",url:URLS.mock,label:"Confirm With Another Test"};
else nextAction={title:"Maintain readiness and verify official requirements",copy:"Your evidence supports readiness, but continue reviewing current state procedures and the actual vehicle.",url:URLS.study,label:"Review Study Guide"};

return {
inspectionComplete:inspectionComplete,
voiceComplete:voiceComplete,
partsComplete:partsComplete,
practiceComplete:practiceComplete,
mockComplete:mockComplete,
practiceHistory:practiceHistory,
mockHistory:mockHistory,
mockLast:mockLast,
practiceAverage:practiceAverage,
latestPractice:latestPractice,
mockAverage:mockAverage,
latestMock:latestMock,
unanswered:unanswered,
score:score,
confidence:confidence,
stateLabel:stateLabel,
strengths:strengths,
gaps:gaps,
categoryRows:categoryRows,
consistencyText:consistencyText,
consistencyCopy:consistencyCopy,
nextAction:nextAction,
evidenceCount:evidenceCount
};
}

function setEvidence(selector,complete,status,copy,warning){
var card=root.querySelector(selector);
card.classList.toggle("is-complete",!!complete);
card.classList.toggle("is-warning",!!warning&&!complete);
card.querySelector("strong").textContent=status;
card.querySelector("p").textContent=copy;
}

function renderList(selector,items,type){
var host=root.querySelector(selector);
if(!items.length){
host.innerHTML='<div class="ptiq-ready-list-item '+(type==="good"?"is-good":"is-gap")+'"><span>'+(type==="good"?"✓":"!")+'</span><div><strong>No '+(type==="good"?"measured strengths":"major gaps")+' yet</strong><p>More completed training and test evidence will improve this view.</p></div></div>';
return;
}
host.innerHTML=items.map(function(item){
return '<div class="ptiq-ready-list-item '+(type==="good"?"is-good":"is-gap")+'"><span>'+(type==="good"?"✓":"!")+'</span><div><strong>'+item.title+'</strong><p>'+item.copy+'</p></div></div>';
}).join("");
}

function renderHistory(data){
var host=root.querySelector("[data-history-list]");
var rows=[];

data.mockHistory.slice(0,5).forEach(function(item){
rows.push({
title:"Mock Test",
date:item.completedAt,
meta:(item.total||0)+" questions · "+formatTime(item.timeUsedSeconds||0)+" used",
score:Number(item.scorePercent)||0
});
});

data.practiceHistory.slice(0,5).forEach(function(item){
var score=item.total?Math.round((Number(item.correct)||0)/(Number(item.total)||1)*100):0;
rows.push({
title:"Practice Test",
date:item.date,
meta:(item.total||0)+" questions · "+String(item.category||"mixed"),
score:score
});
});

rows.sort(function(a,b){return (b.date||0)-(a.date||0)});
rows=rows.slice(0,8);

if(!rows.length){
host.innerHTML='<div class="ptiq-history-row"><div><strong>No completed test history</strong><small>Finish a Practice Test or Mock Test to begin the trend.</small></div><span>—</span><em>—</em></div>';
return;
}

host.innerHTML=rows.map(function(row){
return '<div class="ptiq-history-row"><div><strong>'+row.title+'</strong><small>'+row.meta+'</small></div><span>'+formatDate(row.date)+'</span><em>'+row.score+'%</em></div>';
}).join("");
}

function render(){
try{localStorage.setItem("ptiq_readiness_complete","1")}catch(e){}
var data=analyze();

root.querySelector("[data-readiness-state]").textContent=data.stateLabel;
root.querySelector("[data-readiness-score]").textContent=data.score;
root.querySelector("[data-score-ring]").style.background=
"radial-gradient(circle at center,#0b1c27 58%,transparent 60%),conic-gradient(var(--cyan) 0 "+data.score+"%,rgba(255,255,255,.08) "+data.score+"% 100%)";

var summary;
if(data.stateLabel==="Ready to Test")summary="Multiple signals support readiness. Continue verifying official requirements and keep the result current.";
else if(data.stateLabel==="Nearly Ready")summary="The foundation is strong, but one or more gaps still need confirmation.";
else if(data.stateLabel==="Building Readiness")summary="Progress is visible, but the current evidence is not strong enough to rely on yet.";
else summary="Several core training or testing signals are still missing.";

root.querySelector("[data-readiness-summary]").textContent=summary;
root.querySelector("[data-confidence]").textContent=data.confidence;
root.querySelector("[data-confidence-copy]").textContent=
data.confidence==="High evidence"?"Multiple completed training and testing signals support this score.":
data.confidence==="Moderate evidence"?"The score has useful evidence but still needs more repeated results.":
"Complete more training and testing before relying heavily on this score.";

setEvidence("[data-evidence-inspection]",data.inspectionComplete,data.inspectionComplete?"Complete":"Not complete",data.inspectionComplete?"Guided inspection training is complete.":"Complete the guided inspection trainer.",true);
setEvidence("[data-evidence-voice]",data.voiceComplete,data.voiceComplete?"Complete":"Not complete",data.voiceComplete?"Spoken inspection practice is complete.":"Complete spoken inspection practice.",true);
setEvidence("[data-evidence-parts]",data.partsComplete,data.partsComplete?"Complete":"Not complete",data.partsComplete?"Visual component recognition is complete.":"Complete visual component recognition.",true);

setEvidence("[data-evidence-practice]",data.practiceComplete,
data.practiceAverage!==null?data.practiceAverage+"% recent average":"No completed tests",
data.practiceAverage!==null?data.practiceHistory.length+" completed practice result"+(data.practiceHistory.length===1?"":"s")+".":"Finish an untimed practice session.",
data.practiceAverage!==null&&data.practiceAverage<80);

setEvidence("[data-evidence-mock]",data.mockComplete,
data.latestMock!==null?data.latestMock+"% latest mock":"No completed mock test",
data.latestMock!==null?(data.unanswered+" unanswered on latest result."):"Complete a timed simulation.",
data.latestMock!==null&&(data.latestMock<80||data.unanswered>0));

setEvidence("[data-evidence-consistency]",data.mockHistory.length>=2,
data.consistencyText,
data.consistencyCopy,
data.mockHistory.length>=2&&data.consistencyText!=="Consistent");

renderList("[data-strengths]",data.strengths,"good");
renderList("[data-gaps]",data.gaps,"gap");

var breakdown=root.querySelector("[data-category-breakdown]");
if(!data.categoryRows.length){
breakdown.innerHTML='<div class="ptiq-category-row"><span>No category data yet</span><i><b style="width:0%"></b></i><strong>—</strong></div>';
root.querySelector("[data-weakest-label]").textContent="Waiting for test data";
}else{
breakdown.innerHTML=data.categoryRows.map(function(row){
return '<div class="ptiq-category-row"><span>'+row.name+'</span><i><b style="width:'+row.percent+'%"></b></i><strong>'+row.correct+'/'+row.total+' · '+row.percent+'%</strong></div>';
}).join("");
root.querySelector("[data-weakest-label]").textContent="Weakest: "+data.categoryRows[0].name+" · "+data.categoryRows[0].percent+"%";
}

root.querySelector("[data-plan-title]").textContent=data.nextAction.title;
root.querySelector("[data-plan-copy]").textContent=data.nextAction.copy;
root.querySelector("[data-plan-actions]").innerHTML=
'<a class="ptiq-btn ptiq-btn--primary" href="'+data.nextAction.url+'">'+data.nextAction.label+' →</a>'+
'<a class="ptiq-btn ptiq-btn--secondary" href="'+URLS.study+'">Review Study Guide</a>';

renderHistory(data);
root.querySelector("[data-last-updated]").textContent="Updated "+new Date().toLocaleTimeString(undefined,{hour:"numeric",minute:"2-digit"});
}

root.querySelector("[data-refresh]").addEventListener("click",function(){
render();
root.querySelector("[data-readiness-card]").scrollIntoView({behavior:"smooth",block:"center"});
});

window.addEventListener("storage",render);
render();
})();